import React, { FC } from 'react';

type PropsT = {
  fill?: string;
  onClick?: () => void;
  className?: string;
};

const CloseIcon: FC<PropsT> = ({ fill = 'currentColor', onClick, className }) => (
  <svg className={className} onClick={!!onClick ? () => onClick() : () => false } width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9999 13.2428L4.47042 20.7722C4.16706 21.0756 3.67278 21.0773 3.37451 20.769C3.30769 20.6999 3.27021 20.6598 3.24783 20.6348C2.95584 20.31 2.93292 19.824 3.24179 19.5151L10.757 11.9999L3.22752 4.47041C2.92416 4.16705 2.92416 3.6752 3.22752 3.37184L3.37184 3.22752C3.6752 2.92416 4.16705 2.92416 4.47041 3.22752L11.9999 10.757L19.5294 3.22752C19.8327 2.92416 20.3246 2.92416 20.6279 3.22752L20.7723 3.37184C21.0756 3.6752 21.0756 4.16705 20.7723 4.47041L13.2428 11.9999L20.7722 19.5294C21.0756 19.8327 21.0773 20.327 20.769 20.6253C20.6999 20.6921 20.6598 20.7296 20.6348 20.7519C20.31 21.0439 19.824 21.0668 19.5151 20.758L11.9999 13.2428Z"
      fill={fill} />
  </svg>
);

export default CloseIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
  onClick?: () => void;
  className?: string;
};

const CloseIcon: FC<PropsT> = ({ fill = 'currentColor', onClick, className }) => (
  <svg className={className} onClick={!!onClick ? () => onClick() : () => false } width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9999 13.2428L4.47042 20.7722C4.16706 21.0756 3.67278 21.0773 3.37451 20.769C3.30769 20.6999 3.27021 20.6598 3.24783 20.6348C2.95584 20.31 2.93292 19.824 3.24179 19.5151L10.757 11.9999L3.22752 4.47041C2.92416 4.16705 2.92416 3.6752 3.22752 3.37184L3.37184 3.22752C3.6752 2.92416 4.16705 2.92416 4.47041 3.22752L11.9999 10.757L19.5294 3.22752C19.8327 2.92416 20.3246 2.92416 20.6279 3.22752L20.7723 3.37184C21.0756 3.6752 21.0756 4.16705 20.7723 4.47041L13.2428 11.9999L20.7722 19.5294C21.0756 19.8327 21.0773 20.327 20.769 20.6253C20.6999 20.6921 20.6598 20.7296 20.6348 20.7519C20.31 21.0439 19.824 21.0668 19.5151 20.758L11.9999 13.2428Z"
      fill={fill} />
  </svg>
);

export default CloseIcon;
